(function() {
  'use strict';

  /**
   * @ngdoc service
   * @name webAgro1App.dashboardRegisteredWidgets
   * @description
   * # dashboardRegisteredWidgets
   * Value in the webAgro1App.
   */
  angular
    .module('webAgro1App')
    .value('dashboardRegisteredWidgets', [
      /**
       * Dias sem visita aos talhões
       */
      {
        name: 'widgetTalhoesDiasSemVisita',
        title: 'Dias sem visita aos talhões',
        directive: 'widget-talhoes-dias-sem-visita',
        dataModelOptions: {
          propriedade: null
        },
        attrs: {
          data: 'widget'
        },
        settingsModalOptions: {
          templateUrl: 'views/widgets/visitas/edit.html'
        },
        size: {
          width: '500px'
        },
        widthUnits: 'px',
        style: {
          maxWidth: '100%',
          minWidth: '400px'
        }
      },

      /**
       * Indicadores de Pragas vs Aplicações
       */
      {
        name: 'widgetPragasvsAplicacoes',
        title: 'Indicadores de Pragas vs Aplicações',
        directive: 'widget-pragas-vs-aplicacoes',
        dataModelOptions: {
          propriedade: null,
          safra: null,
          gleba: null,
          tipo: null,
          grupo_insumo: null
        },
        attrs: {
          data: 'widget'
        },
        settingsModalOptions: {
          templateUrl: 'views/widgets/pragas-vs-aplicacoes/edit.html'
        },
        size: {
          width: '100%'
        },
        widthUnits: '%',
        style: {
          maxWidth: '100%',
          minWidth: '800px'
        }
      },

      /**
       * Dados climáticos - Estações meteorológicas
       */
      {
        name: 'widgetEstacaoMeteorologica',
        title: 'Estação Meteorológica',
        directive: 'widget-estacao-meteorologica',
        dataModelOptions: {
          propriedade: null
        },
        attrs: {
          data: 'widget'
        },
        settingsModalOptions: {
          templateUrl: 'views/widgets/estacao-meteorologica/edit.html'
        },
        size: {
          width: '33%'
        },
        widthUnits: '%',
        style: {
          maxWidth: '100%',
          minWidth: '300px'
        }
      },

      /**
       * Protótipo Cronograma
       */
      {
        name: 'widgetCronograma',
        title: 'Cronograma',
        directive: 'widget-cronograma',
        dataModelOptions: {
          propriedade: null,
          gleba: null,
          intervalBefore: 15,
          intervalAfter: 15,
          usuario: null,
          cultura: null,
          tipos: []
        },
        attrs: {
          data: 'widget'
        },
        settingsModalOptions: {
          templateUrl: 'views/widgets/cronograma/edit.html'
        },
        size: {
          width: '50%'
        },
        widthUnits: '%',
        style: {
          maxWidth: '100%',
          minWidth: '500px',
          minHeight: '280px'
        }
      },

      /**
       * Pluviômetros
       */
      {
        name: 'widgetPluviometros',
        title: 'Pluviômetros',
        directive: 'widget-pluviometros',
        dataModelOptions: {
          propriedade: null,
          dataInicial: null,
          dataFinal: null
        },
        attrs: {
          data: 'widget'
        },
        settingsModalOptions: {
          templateUrl: 'views/widgets/pluviometros/edit.html',
          controller: 'WidgetPluviometrosSettingsCtrl',
          controllerAs: 'settings'
        },
        size: {
          width: '50%'
        },
        widthUnits: '%',
        style: {
          maxWidth: '100%',
          minWidth: '200px',
          minHeight: '200px'
        }
      },

      /**
       * Acumulado de Chuva
       */
      {
        name: 'widgetAcumuladoChuva',
        title: 'Acumulado de Chuva',
        directive: 'widget-acumulado-chuva',
        dataModelOptions: {
          propriedade: null,
          dataInicial: null,
          dataFinal: null
        },
        attrs: {
          data: 'widget'
        },
        settingsModalOptions: {
          templateUrl: 'views/widgets/pluviometros/edit.html',
          controller: 'WidgetPluviometrosSettingsCtrl',
          controllerAs: 'settings'
        },
        size: {
          width: '25%'
        },
        widthUnits: '%',
        style: {
          maxWidth: '100%',
          minWidth: '100px',
          minHeight: '300px'
        }
      },

      /**
       * Acumulado de Chuva por período
       */
      {
        name: 'widgetAcumuladoChuvaPeriodo',
        title: 'Acumulado de Chuva por Período',
        directive: 'widget-acumulado-chuva-periodo',
        dataModelOptions: {
          propriedade: null,
          pluviometro: null,
          dataInicial: null,
          dataFinal: null,
          daysInterval: null
        },
        attrs: {
          data: 'widget'
        },
        settingsModalOptions: {
          templateUrl: 'views/widgets/acumulado-chuva-periodo/edit.html',
          controller: 'WidgetAcumuladoChuvaPeriodoSettingsCtrl',
          controllerAs: 'settings'
        },
        size: {
          width: '25%'
        },
        widthUnits: '%',
        style: {
          maxWidth: '100%',
          minWidth: '100px',
          minHeight: '300px'
        }
      }
    ]);
}());
